/**
 * @flow
 * @relayHash e7c341f4a8ed95bc998b164f9d96a770
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserAddInput = {
  name?: ?string,
  password?: ?string,
  email?: ?string,
  active?: ?boolean,
  canDelete?: ?boolean,
  blocked?: ?boolean,
  testText?: ?string,
};
export type UserAddMutationVariables = {|
  input: UserAddInput
|};
export type UserAddMutationResponse = {|
  +UserAdd: ?{|
    +error: ?string,
    +userEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type UserAddMutation = {|
  variables: UserAddMutationVariables,
  response: UserAddMutationResponse,
|};
*/


/*
mutation UserAddMutation(
  $input: UserAddInput!
) {
  UserAdd(input: $input) {
    error
    userEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UserAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "UserAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UserAddInput!"
      }
    ],
    "concreteType": "UserAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UserAddMutation",
  "id": null,
  "text": "mutation UserAddMutation(\n  $input: UserAddInput!\n) {\n  UserAdd(input: $input) {\n    error\n    userEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "UserAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd47824f9de3a5a43b7e47702250d6521';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/UserAddMutation.graphql.js